window._ = require('lodash');
window.Popper = require('popper.js/dist/umd/popper');
window.$ = window.jQuery = require('jquery');
require('jquery-validation');
require('bootstrap');

//Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
var token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

//sticky-kit
require('sticky-kit/dist/sticky-kit');

//fontawesome
require('@fortawesome/fontawesome-free/js/all.min.js');

//Flickity
window.Gallery = require('flickity-imagesloaded');
require('flickity-fullscreen');
require('flickity-as-nav-for');
require('flickity-bg-lazyload');

//Packery
window.Grid = require('packery');

//Isotope
window.Isotope = require('isotope-layout');

require('./sad-page-globals.js');


//////////////////
// WEBPACK FOOTER
// ./resources/assets/page_assets/js/sad-page.js
// module id = 20
// module chunks = 0